export const COUNTRY_CODE_KEY_MAP = {
  SA: 'ads_ksa',
  AE: 'ads_uae',
  QA: 'ads_qat',
  OM: 'ads_omn',
  KW: 'ads_kwt',
  BH: 'ads_bhr',
}

export const COUNTRY_FULL_NAME_KEY_MAP = {
  SA: 'ads_ksa_full',
  AE: 'ads_uae_full',
  QA: 'ads_qat_full',
  OM: 'ads_omn_full',
  KW: 'ads_kwt_full',
  BH: 'ads_bhr_full',
}
